export default {
  mounted() {
    this.getProps();
  },
  methods: {
    getProps() {
      const props = this.$vnode.elm.attributes;
      Object.keys(props).forEach((key) => {
        this.$set(this.props, props[key].name, props[key].nodeValue);
      });
    },
  },
  data() {
    return {
      props: {},
    };
  },
};



// WEBPACK FOOTER //
// ./mixins/DynamicProps.js